import { DateUtil, ObjectUtils } from '@rp/utils';
import { PaginationRequest, SortingRequest } from '@rp/shared/models';
import { PaginationAdapter, SortingAdapter } from '@rp/shared/adapters';

import { PayoutWebmasterFilter, PayoutWebmasterFilterRest } from '../models';

const toRest = (
  filter: PayoutWebmasterFilter,
  pagination: PaginationRequest,
  sorting: SortingRequest,
) => ({
  ...PaginationAdapter.toRest(pagination),
  ...ObjectUtils.stripEmptyFields<Omit<PayoutWebmasterFilterRest, 'limit' | 'page'>>(
    {
      dateFrom: filter?.range?.startDate
        ? DateUtil.toISOStringWithStartTime(filter.range.startDate)
        : '',
      dateTo: filter?.range?.endDate ? DateUtil.toISOStringWithEndTime(filter.range.endDate) : '',
      ...SortingAdapter.toRest(sorting),
    },
    true,
  ),
});

export const WebmasterFiltersAdapter = {
  toRest,
};
